import { ITypedReduxAction } from '../../../common/types/redux/actionType';

export enum EViewedCianIdsActionType {
  Reset = 'viewedCianIds/reset',
}

export type TResetViewedCianIds = ITypedReduxAction<EViewedCianIdsActionType.Reset>;

export type TViewedCianIdsActions = TResetViewedCianIds;
